import { makeVar } from '@apollo/client';
import type { GridState } from '@cmg/data-grid';
import { getColDefId } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../graphql';
import { statusColDef } from './columns/status';
import type { FirmInvestorContactsGridItemFragment } from './graphql/__generated__';

export const refetchFirmInvestorContactsGridReactiveVar = makeVar(false);

export type FirmsInvestorContactsGridContext = {
  onEditInvestorContact: (contact: FirmInvestorContactsGridItemFragment) => void;
};

export const INITIAL_INVESTOR_CONTACTS_GRID_STATE: GridState = {
  filter: {
    filterModel: {
      [getColDefId(statusColDef)]: {
        values: [RolodexRecordStatus.Effective],
        filterType: 'set',
      },
    },
  },
};
